export const FEATURE_ACCESS_SEGMENT = "/access";

export const FeatureSegments = {
    compensation: "/features/compensation",
    "compensation-classic": "/features/compensation-classic",
    engagement: "/features/engagement",
    goals: "/features/goals",
    "good-vibes": "/features/good-vibes",
    meetings: "/features/meetings",
    "org-chart": "/features/org-chart",
    "performance-reviews": "/features/performance-reviews",
    plans: "/features/plans"
} as const;
